var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.variant === 'text' ? _c('h3', {
    staticClass: "my-1"
  }, [_vm._v(_vm._s(_vm.label))]) : _c('h3');
}
var staticRenderFns = []

export { render, staticRenderFns }